import React from "react";
import { Link } from 'react-router-dom';

function RaceCard({ race }) {
  // Prefer an explicit DB-provided image filename, otherwise build a slug from race.location
  const dbImage = race.race_track_image || race.raceTrackImage || null;
  const rawLocation = race.location || '';
  const slug = rawLocation ? rawLocation.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') : '';

  // Build an ordered list of candidate URLs to try. Handle cases where dbImage already contains an extension or path.
  const candidates = [];
  if (dbImage) {
    if (dbImage.includes('/')) {
      const url = dbImage.startsWith('http')
        ? dbImage
        : `/${dbImage.replace(/^\/?/, '')}`;
      candidates.push(url);
    } else if (/\.[a-zA-Z0-9]+$/.test(dbImage)) {
      candidates.push(`/assets/race-tracks/${dbImage}`);
    } else {
      candidates.push(`/assets/race-tracks/${dbImage}.png`);
      candidates.push(`/assets/race-tracks/${dbImage}.svg`);
    }
  }

  return (
    <Link to={`/races/${race.id}`} className="block">
      <div className="bg-white shadow-lg rounded-xl overflow-hidden hover:shadow-2xl transition border-2 border-gray-300 hover:border-yellow-400 hover:scale-105">
      {candidates.length > 0 ? (
        <div className="h-40 bg-gray-100">
          <img
            src={candidates[0]}
            alt={race.name}
            className="w-full h-full object-cover"
            onError={(e) => {
              // Try next candidate in list, otherwise hide
              const img = e.currentTarget;
              img.onerror = null; // prevent loops
              const current = img.src;
              const idx = candidates.findIndex((c) => c === current);
              const next = candidates[idx + 1];
              if (next) {
                img.src = next;
                img.onerror = (ev) => {
                  // if the fallback fails, hide the image
                  ev.currentTarget.style.display = 'none';
                };
                return;
              }
              img.style.display = 'none';
            }}
          />
        </div>
      ) : (
        <div className="h-40 bg-gray-100 flex items-center justify-center text-gray-400">No image</div>
      )}

      <div className="p-6">
        <h3 className="text-xl font-semibold text-black">{race.name}</h3>
        <p className="text-sm text-gray-500">{race.location}</p>
        <p className="mt-2 text-gray-700">
          {race.start_date ? new Date(race.start_date).toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' }) : "TBD"}
          {race.end_date ? ` — ${new Date(race.end_date).toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' })}` : ""}
        </p>
      </div>
      </div>
    </Link>
  );
}

export default RaceCard;
